module.exports = __webpack_public_path__ + "static/media/github.afdc9539.svg";